import { render, staticRenderFns } from "./PlansSummary.vue?vue&type=template&id=4850cb40"
import script from "./PlansSummary.vue?vue&type=script&lang=js"
export * from "./PlansSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports